import { h, Component, Fragment } from 'preact';
import ProductsAPI from '../api/ProductsAPI';
import CategoriesAPI from '../api/CategoriesAPI';
import BrandsAPI from '../api/BrandsAPI';
import AnimalsAPI from '../api/AnimalsAPI';
import TableAPI from '../api/TableAPI';
import Posts from '../components/Posts';
import Filter from './Filter';
import OrderBy from '../components/Orderby'
import Loader from '../components/Loader';
// import Pagination from '../components/Pagination'
import { clearAllBodyScrollLocks } from 'body-scroll-lock';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterLabel: props.filterLabel, 
      showMoreLabel: props.showMore,
      showLessLabel: props.showLess,
      suggestedLabel: props.suggestedLabel,
      itemsLabel: props.itemsLabel,
      addingLabel: props.addingLabel,
      readMoreLabel: props.readMoreLabel,
      labelAnimal: props.labelAnimal,
      labelCategory: props.labelCategory,
      labelBrand: props.labelBrand,
      uspOne: props.uspOne,
      uspTwo: props.uspTwo,
      uspThree: props.uspThree,
      isLoading: true,
      posts: [],
      allPosts: [],
      currentSlug: '',
      totalAmountProducts: null,
      categories: [],
      animals: [],
      brands: [],
      currentCategories: [],
      currentAnimals: [],
      currentBrands: [],
      startAnimal: props.startAnimal,
      startBrand: props.startBrand,
      startCategory: props.startCategory,
      suggestedAnimal: props.suggestedAnimal,
      suggestedBrand: props.suggestedBrand,
      suggestedCategory: props.suggestedCategory,
      currentLanguage: props.currentLanguage,
      loggedIn: props.loggedIn,
      count: 14,
      offset: 0,
      currentPage: 1,
      order: '',
      showAll: false,
      typeShop: '',
      searchText: '',
      searchActive: false,
      filterMenu: false,
      resetUrlParam: false,
    };
  }

  componentDidMount() {
    if (this.state.startAnimal) {
      const splitAnimal = this.state.startAnimal.split(';');
      this.setState({ currentAnimals: splitAnimal })
    }

    if (this.state.startBrand) {
      const splitBrand = this.state.startBrand.split(';');
      this.setState({ currentBrands: splitBrand })
    }

    if (this.state.startCategory) {
      const splitCategory = this.state.startCategory.split(';');
      this.setState({ currentCategories: splitCategory })
    }

    if (this.state.suggestedAnimal) {
      const splitAnimals = this.state.suggestedAnimal.split(';');
      this.setState({ suggestedAnimal: splitAnimals })
    }

    if (this.state.suggestedBrand) {
      const splitBrands = this.state.suggestedBrand.split(';');
      this.setState({ suggestedBrand: splitBrands })
    }

    if (this.state.suggestedCategory) {
      const splitCategories = this.state.suggestedCategory.split(';');
      this.setState({ suggestedCategory: splitCategories })
    }

    if (this.state.currentLanguage == 'en') this.setState({ currentLanguage: '' })

    this.state.resetUrlParam == false;

    // Shop type
    const currentURL = window.location.href;
    let shopType = '';

    if (currentURL.includes('pet')) shopType = 'pet';
    if (currentURL.includes('vet')) shopType = 'vet';
    if (shopType) this.setState({ typeShop: shopType });

    // Pagination
    // const queryString = window.location.search
    // const urlParams = new URLSearchParams(queryString)
    // const currentPage = urlParams.get('current_page')

    // if (currentPage) {
    //   this.setState(
    //     {
    //       posts: [],
    //       allPosts: [],
    //       currentPage: Number(currentPage),
    //       offset: this.state.count * Number(currentPage) - this.state.count
    //     }
    //   )
    // }

    if (!this.state.resetUrlParam) {
      this.fetchAnimalsFilterUrl(); 
      this.fetchCategoriesFilterUrl();
      this.fetchBrandsFilterUrl();
    }
    this.fetchCategoriesFilters().then(() => {
      this.fetchAnimalsFilters().then(() => {
        this.fetchBrandsFilters().then(() => {
          this.initiate()
          this.fetchAllPosts();
        }).catch(error => {})
      }).catch(error => {})
    }).catch(error => {

    });
  }

  initiate() {
    this.fetchProducts();
  }

  fetchProducts() {
    this.setState({ isLoading: true })

    ProductsAPI.all(this.state)
    .then(response => {
      this.setState({
        totalAmountProducts: response.headers.get('x-wp-total')
      })
      return response.json()
    })
    .then(data => {
      this.setState({
        posts: [...this.state.posts, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        fetchError: true,
        isLoading: false
      })
      throw Error(`Fetching products failed: ${error}`)
    })
  }

  // Fetch Categories
  fetchCategoriesFilters() {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })

      CategoriesAPI.all(this.state)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState(() => {
          return {
            categories: data,
            isLoading: false
          }
        }, this.setCurrentCategoryWithSlug)
        resolve()
      }).catch(error => {
        this.setState({
          fetchError: true,
          isLoading: false
        })
        reject()
        throw Error(`Fetching products failed: ${error}`)
      })
    })
  }

  fetchCategoriesFilterUrl() {
    const currentURL = window.location.href;
    let splittedUrl = currentURL.split('/');
    const categoryOptions = ['product_category', 'product-category', 'vare-kategori', 'categorie-produit', 'produkt-kategorie', 'categoria-prodotto', 'product-categorie', 'produktkategori', 'produkt-kategori', 'categoria-producto']

    categoryOptions.forEach(categoryOption => {
      if (currentURL.includes(categoryOption)) {
        let indexCategory = splittedUrl.indexOf(categoryOption);
        const indexCategoryElement = indexCategory + 1;
        const categoryElement = splittedUrl[indexCategoryElement];
        this.setState({ currentSlug: categoryElement })
      }
    })
  }

  setCurrentCategoryWithSlug() {
    if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
      let currentCategory = this.state.categories.filter((category) => category.slug == this.state.currentSlug)
      currentCategory = currentCategory[0]

      if (currentCategory && this.state.filterMenu == false) {
        const currentCategories = [...this.state.currentCategories]
        if (!currentCategories.includes(currentCategory.id)) {
          currentCategories.push(currentCategory.id)

          let currentCheckbox = document.querySelector(`.c-shop-filter__input[data-id="${currentCategory.id}"]`);
          if (currentCheckbox) {
            let checkboxContainer = currentCheckbox.closest(`.c-shop-filter__checkbox`);
            checkboxContainer.classList.add('chosen');
          }

          this.setState(() => {
            return {
              currentCategories: currentCategories,
              // posts: [],
              offset: 0,
            }
          })
        }
      }
    }
  }

  // Fetch Animals
  fetchAnimalsFilters() {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })

      AnimalsAPI.all(this.state)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState(() => {
          return {
            animals: data,
            isLoading: false
          }
        }, this.setCurrentAnimalWithSlug)
        resolve()
      }).catch(error => {
        this.setState({
          fetchError: true,
          isLoading: false
        })
        reject()
        throw Error(`Fetching products failed: ${error}`)
      })
    })
  }

  fetchAnimalsFilterUrl() {
    const currentURL = window.location.href;
    let splittedUrl = currentURL.split('/');
    const animalCategoryOptions = ['animal_category', 'dyr', 'djur']

    animalCategoryOptions.forEach(animalCategoryOption => {
      if (currentURL.includes(animalCategoryOption)) {
        let indexCategory = splittedUrl.indexOf(animalCategoryOption);
        const indexCategoryElement = indexCategory + 1;
        const categoryElement = splittedUrl[indexCategoryElement];
        this.setState({ currentSlug: categoryElement })
      }
    })
  }

  setCurrentAnimalWithSlug() {
    if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
      let currentAnimal = this.state.animals.filter((animal) => animal.slug == this.state.currentSlug)
      currentAnimal = currentAnimal[0]

      if (currentAnimal && this.state.filterMenu == false) {
        const currentAnimals = [...this.state.currentAnimals]
        if (!currentAnimals.includes(currentAnimal.id)) {
          currentAnimals.push(currentAnimal.id)

          let currentCheckbox = document.querySelector(`.c-shop-filter__input[data-id="${currentAnimal.id}"]`);
          if (currentCheckbox) {
            let checkboxContainer = currentCheckbox.closest(`.c-shop-filter__checkbox`);
            checkboxContainer.classList.add('chosen');
          }

          this.setState(() => {
            return {
              currentAnimals: currentAnimals,
              offset: 0,
            }
          })
        }
      }
    }
  }

  // Fetch Brands
  fetchBrandsFilters() {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })

      BrandsAPI.all(this.state)
     .then(response => {
        return response.json()
      })
     .then(data => {
        this.setState(() => {
          return {
            brands: data,
            isLoading: false
          }
        }, this.setCurrentBrandWithSlug)
        resolve()
      }).catch(error => {
        this.setState({
          fetchError: true,
          isLoading: false
        })
        reject()
        throw Error(`Fetching products failed: ${error}`)
      })
    })
  }

  fetchBrandsFilterUrl() {
    const currentURL = window.location.href;
    let splittedUrl = currentURL.split('/');
    const categoryOptions = ['product_category', 'vare-kategori', 'categorie-produit', 'produkt-kategorie', 'categoria-prodotto', 'product-categorie', 'produktkategori', 'produkt-kategori', 'categoria-producto']

    categoryOptions.forEach(categoryOption => {
      if (currentURL.includes(categoryOption)) {
        let indexCategory = splittedUrl.indexOf(categoryOption);
        const indexCategoryElement = indexCategory + 1;
        const categoryElement = splittedUrl[indexCategoryElement];
        this.setState({ currentSlug: categoryElement })
      }
    })
  }

  setCurrentBrandWithSlug() {
    if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
      let currentBrand = this.state.brands.filter((category) => category.slug == this.state.currentSlug)
      currentBrand = currentBrand[0]

      if (currentBrand && this.state.filterMenu == false) {
        const currentBrands = [...this.state.currentBrands]
        if (!currentBrands.includes(currentBrand.id)) {
          currentBrands.push(currentBrand.id)
          this.setState(() => {
            return {
              currentBrands: currentBrands,
              offset: 0,
            }
          })
        }
      }
    }
  }

  fetchAllPosts() {
    this.setState({ isLoading: true })

    TableAPI.all(this.state)
    .then(response => {
      return response.json()
    })
    .then(data => {
      this.setState({
        allPosts: [...this.state.allPosts, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        fetchError: true,
        isLoading: false
      })
      throw Error(`Fetching products failed: ${error}`)
    })
  }

  handleChange(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]];
    const targetID = e.currentTarget.dataset.id * 1;

    if (currentElements.includes(targetID)) {
      currentElements = currentElements.filter(item => item !== targetID);
    } else {
      currentElements.push(targetID);
    }

    // let checkboxContainer = e.currentTarget.closest('.c-shop-filter__checkbox');
    // (checkboxContainer.classList.contains('chosen')) ? checkboxContainer.classList.remove('chosen') : checkboxContainer.classList.add('chosen');

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        // allPosts: [],
        offset: 0,
      };
    }, this.initiate);
  }

  handleSuggested(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]];

    if (currentElements.includes(e.currentTarget.dataset.id)) {
      currentElements = currentElements.filter(item => item !== e.currentTarget.dataset.id);
    } else {
      currentElements.push(e.currentTarget.dataset.id);
    }

    // let currentCheckbox = document.querySelector(`.c-shop-filter__input[data-id="${e.currentTarget.dataset.id}"]`);
    // if (currentCheckbox) {
    //   let checkboxContainer = currentCheckbox.closest(`.c-shop-filter__checkbox`);
    //   checkboxContainer.classList.add('chosen');
    // }

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        // allPosts: [],
        offset: 0,
      };
    }, this.initiate);
  }

  handleRemove(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]];
    const targetID = e.currentTarget.dataset.id * 1
    currentElements = currentElements.filter(item => item !== targetID)

    // let currentCheckbox = document.querySelector(`.c-shop-filter__input[data-id="${e.currentTarget.dataset.id}"]`);
    // let checkboxContainer = currentCheckbox ? currentCheckbox.closest(`.c-shop-filter__checkbox`) : '';
    // if (checkboxContainer) checkboxContainer.classList.remove('chosen');

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        // allPosts: [],
        offset: 0,
        currentSlug: '',
        filterMenu: true,
        resetUrlParam: true
      };
    }, this.initiate);
  }

  handleClick(e) {
    // Add start filters to the state
    const splitAnimal = this.state.startAnimal
      ? this.state.startAnimal.split(';')
      : []
    const splitBrand = this.state.startBrand
      ? this.state.startBrand.split(';')
      : []
    const splitCategory = this.state.startCategory
      ? this.state.startCategory.split(';')
      : []

    this.setState(() => {
      return {
        currentCategories: splitCategory,
        currentAnimals: splitAnimal,
        currentBrands: splitBrand,
        // searchText: '',
        posts: [],
        // allPosts: [],
        offset: 0,
        resetUrlParam: true
      }
    }, this.initiate)
  }

  handleToggle() {
    if (this.state.filterActive) {
      clearAllBodyScrollLocks();
    }
    this.setState({ filterActive: !this.state.filterActive });
  }

  updateURL(page) {
    // Update URL so page is set on refresh
    if (history.pushState) {
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?current_page=${page}`
      window.history.pushState({ path: newurl }, '', newurl)
    }
  }

  handlePageClick(e) {
    // Multiply the count by the currentPage to get the correct offset
    if (e.currentTarget.dataset.page) {
      this.updateURL(e.currentTarget.dataset.page)
      this.setState(
        {
          posts: [],
          allPosts: [],
          currentPage: Number(e.currentTarget.dataset.page),
          offset:
            this.state.count * Number(e.currentTarget.dataset.page) -
            this.state.count
        },
        this.initiate
      )
    }
  }

  handleOrderChoice(order) {
    this.setState(
      {
        order: order,
        posts: [],
        // allPosts: [],
        offset: 0
      },
      this.initiate
    )
  }

  handleShowMore(e) {
    this.setState(prevState => {
      return {
        offset: prevState.offset + this.state.count,
        count: this.state.count + this.state.count
      }
    }, this.fetchProducts)
  }

  handleSearch(searchText) {
    this.setState({
      searchText: searchText
    })
  }

  handleSearchSubmit() {
    this.setState({
      posts: [],
      allPosts: [],
      categories: [],
      animals: [],
      brands: [],
    }, this.initiate)
  }

  render() {
    // console.log('this.state', this.state);
    return (
      <div className="c-shop-overview__app-container">
        <div className="c-shop-overview__filter-top-bar u-flex u-flex-sb">
          <div className="c-shop-overview__filter-button" onClick={this.handleToggle.bind(this)}>
            {this.state.filterActive ? (
              <svg className="c-icon c-shop-overview__filter-icon active">
                <use href="#close" xlinkHref="#close" />
              </svg>
            ) : (
              <svg className="c-icon c-shop-overview__filter-icon">
                <use href="#filter" xlinkHref="#filter" />
              </svg>
            )}
            Filter
          </div>

          <div className="c-shop-overview__filter-button">
            <OrderBy
              order={this.state.order}
              onSelectOrder={this.handleOrderChoice.bind(this)}
              postsLoading={this.state.isLoading}
            />
          </div>
        </div>
        <div class="c-shop-overview__filter-container">
          <Filter
            posts={this.state.posts}
            allPosts={this.state.allPosts}
            categories={this.state.categories}
            animals={this.state.animals}
            brands={this.state.brands}
            labelAnimal={this.state.labelAnimal}
            labelCategory={this.state.labelCategory}
            labelBrand={this.state.labelBrand}
            currentCategories={this.state.currentCategories}
            currentAnimals={this.state.currentAnimals}
            currentBrands={this.state.currentBrands}
            handleChange={this.handleChange.bind(this)}
            handleClick={this.handleClick.bind(this)}
            filterActive={this.state.filterActive}
            handleToggle={this.handleToggle.bind(this)}
            isLoading={this.state.isLoading}
            placeholder={this.state.filterLabel}
            filterLabel={this.state.filterLabel}
            showMoreLabel={this.state.showMoreLabel}
            showLessLabel={this.state.showLessLabel}
            handleRemove={this.handleRemove.bind(this)}
            handleReset={this.handleClick.bind(this)}
            searchText={this.state.searchText}
          />
        </div>
        <div class="c-shop-overview__posts-wrapper">
          {this.state.posts.length > 0 ? (
            <div class="c-shop-overview__posts-container">
              <Posts
                posts={this.state.posts}
                offset={this.state.offset}
                itemsLabel={this.state.itemsLabel}
                addLabel={this.state.addingLabel}
                readMoreLabel={this.state.readMoreLabel}
                suggestedLabel={this.state.suggestedLabel}
                loading={this.state.isLoading}
                nrAll={this.state.totalAmountProducts}
                count={this.state.count}
                uspOne={this.state.uspOne}
                uspTwo={this.state.uspTwo}
                uspThree={this.state.uspThree}
                suggestedAnimal={this.state.suggestedAnimal}
                suggestedBrand={this.state.suggestedBrand}
                suggestedCategory={this.state.suggestedCategory}
                categories={this.state.categories}
                animals={this.state.animals}
                brands={this.state.brands}
                handleSuggested={this.handleSuggested.bind(this)}
                order={this.state.order}
                handleOrderChoice={this.handleOrderChoice.bind(this)}
                typeShop={this.state.typeShop}
                currentLanguage={this.state.currentLanguage}
                loggedIn={this.state.loggedIn}
                handleShowMore={this.handleShowMore.bind(this)}
                searchText={this.state.filterLabel}
                onSearch={this.handleSearch.bind(this)}
                onSubmit={this.handleSearchSubmit.bind(this)}
              />

              {/* <Pagination
                count={this.state.count}
                offset={this.state.offset}
                currentPage={this.state.currentPage}
                totalAmountPosts={this.state.allPosts.length}
                handlePageClick={this.handlePageClick.bind(this)} */}
              {/* /> */}
            </div>
          ) : (
            <div className="c-shop-overview__no-posts">
              No results
              <div
                className="c-shop-overview__reset"
                onClick={() => {
                  this.handleClick();
                }}
              >
                Reset filters
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/js/shop/containers/App.js